/**
 * @generated SignedSource<<920041d27e0b8ddd4148630d42cea69a>>
 * @relayHash 82c18ff889d3a6c63cad30c29f6b0aa8
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 82c18ff889d3a6c63cad30c29f6b0aa8

import { ConcreteRequest } from 'relay-runtime';
export type AiResult = "APPOINTMENT_IS_MISSING_CHAT_THREAD_ID" | "BREACHED_CONTENT_FILTER" | "FUNCTION_CALL" | "INVALID_QUESTIONNAIRE_DATA" | "JSON_ERROR" | "MAXIMUM_NUMBER_OF_TOKENS_EXCEEDED" | "MISSING_APPOINTMENT_DATA" | "MISSING_CALL_TRANSCRIPT" | "MISSING_CHAT_TRANSCRIPT" | "MISSING_CLINIBEE_GUIDELINES" | "MISSING_PROMPT_FOR_REQUESTED_LANGUAGE" | "MISSING_QUESTIONNAIRE_DATA" | "MISSING_USER_INPUT" | "MISSING_USER_PROMPT" | "NOT_FOUND_OPEN_AI_PROMPT" | "PROCESS_TIMEOUT" | "SUCCESS" | "TOOL_CALLS" | "UNKNOWN_ERROR" | "UNRESOLVED_PLACEHOLDER" | "UNSUPPORTED_PLACEHOLDER";
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type AiRequestMetadataInput = {
  age: number;
  aiFeatureId: string;
  appointmentId: string;
  gender: Gender;
  progressNoteId?: string | null;
  progressNotes?: ReadonlyArray<ProgressNoteAnamnesisInput> | null;
  specialtyOfPointOfCareForCurrentProgressNote?: string | null;
  targetAgentLanguage?: Language | null;
  userInput?: string | null;
};
export type ProgressNoteAnamnesisInput = {
  anamnesis: string;
  updatedAt: string;
};
export type chChatHealthInformationCopilotQuery$variables = {
  aiRequestMetadata: AiRequestMetadataInput;
};
export type chChatHealthInformationCopilotQuery$data = {
  readonly chatHealthInformationCopilot: {
    readonly healthInformation: {
      readonly allergies: ReadonlyArray<{
        readonly comment: string | null;
        readonly diagnosis: {
          readonly diagnosisCode: string;
          readonly text: string;
        };
      }>;
      readonly conditions: ReadonlyArray<{
        readonly diagnosisCode: string;
        readonly text: string;
      }>;
      readonly medications: ReadonlyArray<string>;
    } | null;
    readonly result: AiResult;
  };
};
export type chChatHealthInformationCopilotQuery = {
  response: chChatHealthInformationCopilotQuery$data;
  variables: chChatHealthInformationCopilotQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "aiRequestMetadata"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "aiRequestMetadata",
    "variableName": "aiRequestMetadata"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "diagnosisCode",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v4 = [
  (v2/*:: as any*/),
  (v3/*:: as any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "comment",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "medications",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "result",
  "storageKey": null
},
v8 = [
  (v2/*:: as any*/),
  (v3/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chChatHealthInformationCopilotQuery",
    "selections": [
      {
        "alias": "chatHealthInformationCopilot",
        "args": (v1/*:: as any*/),
        "concreteType": "ChatHealthInformationCopilotResult",
        "kind": "LinkedField",
        "name": "ch_chatHealthInformationCopilot",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "HealthInformation",
            "kind": "LinkedField",
            "name": "healthInformation",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IcdDiagnosisWithComment",
                "kind": "LinkedField",
                "name": "allergies",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IcdDiagnosis",
                    "kind": "LinkedField",
                    "name": "diagnosis",
                    "plural": false,
                    "selections": (v4/*:: as any*/),
                    "storageKey": null
                  },
                  (v5/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IcdDiagnosis",
                "kind": "LinkedField",
                "name": "conditions",
                "plural": true,
                "selections": (v4/*:: as any*/),
                "storageKey": null
              },
              (v6/*:: as any*/)
            ],
            "storageKey": null
          },
          (v7/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chChatHealthInformationCopilotQuery",
    "selections": [
      {
        "alias": "chatHealthInformationCopilot",
        "args": (v1/*:: as any*/),
        "concreteType": "ChatHealthInformationCopilotResult",
        "kind": "LinkedField",
        "name": "ch_chatHealthInformationCopilot",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "HealthInformation",
            "kind": "LinkedField",
            "name": "healthInformation",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IcdDiagnosisWithComment",
                "kind": "LinkedField",
                "name": "allergies",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IcdDiagnosis",
                    "kind": "LinkedField",
                    "name": "diagnosis",
                    "plural": false,
                    "selections": (v8/*:: as any*/),
                    "storageKey": null
                  },
                  (v5/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IcdDiagnosis",
                "kind": "LinkedField",
                "name": "conditions",
                "plural": true,
                "selections": (v8/*:: as any*/),
                "storageKey": null
              },
              (v6/*:: as any*/)
            ],
            "storageKey": null
          },
          (v7/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "82c18ff889d3a6c63cad30c29f6b0aa8",
    "metadata": {},
    "name": "chChatHealthInformationCopilotQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "116181ef169862bf382d50c781190e16";

export default node;
